export const CMD_ARG_TYPE = {
  NONE: 'none',
  MULTI_SELECT: 'multi-select',
  SINGLE_SELECT: 'single-select',
  BOOL_SELECT: 'bool-select',
  MULTI_KEYWORD: 'multi-keyword',
  OBJ_CONSTRUCT: 'object-construct',
  TEXT_INPUT: 'text-input',
};

export const IQ_TOOL_BUILDING_KIT_TAB_NAMES = {
  AI_TESTING: 'AI_TESTING',
  BUILDING_KIT: 'BUILDING_KIT',
};

export const IQ_TOOL_ACTION_TYPE_COMMAND = 'command';
export const IQ_TOOL_ACTION_TYPE_DIALOG = 'dialog';
export const IQ_TOOL_ACTION_TYPE_RESPONSE = 'response';
export const IQ_TOOL_ACTION_TYPE_WORKFLOW = 'workflow';

export const IQ_TOOL_DIAGRAM_EDITABLE_NODE_TYPES = [
  IQ_TOOL_ACTION_TYPE_COMMAND,
  IQ_TOOL_ACTION_TYPE_DIALOG,
  IQ_TOOL_ACTION_TYPE_WORKFLOW,
];

export const IQ_TOOL_DIAGRAM_EXPANDABLE_NODE_TYPES = [
  IQ_TOOL_ACTION_TYPE_DIALOG,
  IQ_TOOL_ACTION_TYPE_WORKFLOW,
];